import { store } from '../../../../resources/frontend/js/store/index';
import { watch } from 'vue';

export const setupUrlProgressTracking = () => {
    if (!store.state.page.isLanding) return;

    watch(() => store.state.page.step, (newStep, oldStep) => {
        if (newStep !== oldStep) {
            const url = new URL(window.location);
            url.searchParams.set('current_step', newStep);
            window.history.replaceState({}, '', url);
        }
    });

    watch(() => store.state.form.attributes.step, (newStep, oldStep) => {
        if (newStep !== oldStep) {
            const url = new URL(window.location);
            url.searchParams.set('form_step', newStep);
            window.history.replaceState({}, '', url);
        }
    });

    watch(() => store.state.quiz.questionCount, (newCount, oldCount) => {
        if (newCount !== oldCount) {
            const url = new URL(window.location);
            url.searchParams.set('current_question', newCount);
            window.history.replaceState({}, '', url);
        }
    });
};
